import apiService, { ApiError } from './apiService';

const BASE = '/api/v1/admin/purchases';

const request = async (path = '', options = {}, valid = data => !!data) => {
  const response = await apiService.skaiOneRequest(`${BASE}${path}`, options);
  if (!response || response.code !== 'OK' || !valid(response.data)) {
    throw new ApiError(
      'The purchase response could not be read. Please try again.',
      0,
      'INVALID_RESPONSE'
    );
  }
  return response.data;
};

const isPurchase = data =>
  !!data?.id &&
  !!data?.purchase &&
  ['processing', 'completed', 'failed'].includes(data.status);

const manualPurchaseService = {
  getHistory: (params = {}) =>
    request(
      '',
      { params },
      value =>
        Array.isArray(value?.data) &&
        Number.isInteger(value.page) &&
        Number.isInteger(value.size) &&
        Number.isInteger(value.total) &&
        Number.isInteger(value.pageCount)
    ),
  getEvidence: id =>
    request(
      `/evidence/${encodeURIComponent(id)}`,
      { cache: 'no-store' },
      value =>
        !!value?.id &&
        typeof value.fileName === 'string' &&
        typeof value.url === 'string' &&
        /^https?:\/\//.test(value.url) &&
        Number.isFinite(Date.parse(value.expiresAt))
    ),
  searchCreators: search =>
    request('/creators', { params: { search } }, Array.isArray),
  getItems: creatorId =>
    request('/items', { params: { creatorId } }, Array.isArray),
  uploadEvidence: file => {
    const data = new FormData();
    data.append('file', file);
    return request('/evidence', { method: 'POST', data }, value => !!value?.id);
  },
  preview: data =>
    request(
      '/preview',
      { method: 'POST', data },
      value =>
        !!value?.previewToken &&
        !!value?.creator &&
        !!value?.item &&
        Number.isFinite(Date.parse(value.previewExpiresAt))
    ),
  confirm: data => request('', { method: 'POST', data }, isPurchase),
  getPurchase: id => request(`/${encodeURIComponent(id)}`, {}, isPurchase),
  retry: id =>
    request(`/${encodeURIComponent(id)}/retry`, { method: 'POST' }, isPurchase),
};

export default manualPurchaseService;
